import BrainSearchLandingPage from "@/brain-search/internal/BrainSearchLandingPage"
import BrainSearchPage from "@/brain-search/internal/BrainSearchPage"
import BrainSearchSidebar from "@/brain-search/internal/BrainSearchSidebar"
import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { useIsMobile } from "@utils/hook/screenSizeHooks"
import { TestIDProps } from "@utils/typeUtils"
import classNames from "classnames"

function BrainSearchDrawerContent(props: TestIDProps) {
  const { testid = "BrainSearchDrawerContent" } = props
  const classes = useStyles()
  const drawer = useGlobalDrawer("brainSearch")
  const isMobile = useIsMobile()
  const isSidePanel = Boolean(drawer.params.drawerAsk)
  const isWide = !isSidePanel && !isMobile

  return (
    <>
      {isWide && <BrainSearchSidebar />}
      <div
        className={classNames(classes.main, { [classes.bordered]: isWide })}
        data-testid={testid}
      >
        {drawer.params.convId ? <BrainSearchPage /> : <BrainSearchLandingPage />}
      </div>
    </>
  )
}

const useStyles = makeUseStyles((theme) => ({
  main: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
    borderLeft: `1px solid ${theme.palette.divider}`,
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
  bordered: {
    borderTopLeftRadius: theme.measure.borderRadius.large,
    borderBottomLeftRadius: theme.measure.borderRadius.large,
    boxShadow: theme.palette.groovyDepths.boxShadow,
  },
}))

export default BrainSearchDrawerContent
